import { IntelligenceModels } from '@models/intelligence.model';

export namespace OrganizationMembersModels {
  /** Row actions offered by the Cmd+K organization members panel. */
  export enum RowActionId {
    Permissions = 'permissions',
    ForceLogout = 'force-logout',
    ForceResetPassword = 'force-reset-password',
    Edit = 'edit',
    Delete = 'delete',
  }

  export interface DatasetRowActionEvent {
    actionId: string;
    row: IntelligenceModels.Organizations.Member;
  }

  /** Sort directions emitted by the panel's three-state header sort cycle. */
  export enum SortDirection {
    None = 0,
    Asc = 1,
    Desc = -1,
  }
}
